import { graphApi } from '../../api/subgraph/graph-client'
import { PoolWithData, TokenWithData } from '../../api/api-types'
import { Address, BigValue, Wei } from '../../utils/types'
import { calculateApr, calculateAprFromPoolTokenPrices } from '../financials/apr'

export interface QuickPoolLine {
  pool: PoolWithData
  tokens: TokenWithData[]
  tvl: number
  dailyVolume: number
  apr: number
  net_apr_since_inception: number
}

export interface FullPoolLine extends QuickPoolLine {
  userValue?: number // if connected
  userShares?: Wei // if connected
}

export type PartialLine = QuickPoolLine & Partial<FullPoolLine>

export function initPoolProcess(pools: PoolWithData[]): QuickPoolLine[] {
  const lines: QuickPoolLine[] = []

  // TODO: filter pools
  for (const pool of pools) {
    lines.push({
      pool: pool,
      tokens: pool.tokens,
      tvl: pool.tvl,
      dailyVolume: pool.fees.dailyVolume,
      apr: calculateApr(pool.tvl, pool.fees.dailyFees),
      net_apr_since_inception: calculateAprFromPoolTokenPrices(pool.initialPoolTokenPrice, pool.currentPoolTokenPrice, Date.now() - pool.createTimeMs),
    })
  }
  return lines
}

export async function continuePoolProcess(
  quickLines: QuickPoolLine[],
  userAddress?: Address
): Promise<FullPoolLine[]> {
  const lines: FullPoolLine[] = []

  for (const line of quickLines) {
    const pool = line.pool
    const userValue = userAddress
      ? await graphApi.getUserPoolValue(userAddress, pool)
      : undefined

    lines.push({
      pool: pool,
      tokens: pool.tokens,
      userValue: userValue ? userValue.value : undefined,
      userShares: userValue ? userValue.shares : undefined,
      tvl: pool.tvl,
      apr: line.apr,
      dailyVolume: line.dailyVolume,
      net_apr_since_inception: line.net_apr_since_inception
    })
  }
  return lines
}
